import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackCheckbox from "../Input/FeedbackCheckBox";
import FeedbackText from "../Input/FeedbackText";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question11FlashCoachExperience = ({
  helpfulFeatures,
  helpfulFeaturesOthers,
  updateFormData,
  onEnterKeyPress,
  updateSelectionFormData,
  conditionalInputError,
}) => {
  const othersCheckboxIsFilled = helpfulFeatures.filter(
    item => item.id === "6" && item.checked
  );

  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={"Which feature did you find most helpful in the system?"}
        />
        <FeedbackCheckbox
          inputID={"helpfulFeatures"}
          checkBoxList={helpfulFeatures}
          updateSelectionFormData={updateSelectionFormData}
        />
        {(conditionalInputError?.action === "SHOW_TEXT_INPUT" ||
          othersCheckboxIsFilled.length > 0) && (
          <FeedbackText
            inputID={"helpfulFeaturesOthers"}
            inputText={helpfulFeaturesOthers}
            updateFormData={updateFormData}
            onEnterKeyPress={onEnterKeyPress}
            placeHolder={"please specify: ____"}
          />
        )}
      </FeedbackFormLayout>
    </>
  );
};
